import {Base} from "@/api/Base"

export class AuthorityAdd extends Base {
    path = "authority/add"
}